export default "__VITE_ASSET__DGF_Vbes__"